import { resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, withModifiers as _withModifiers, renderList as _renderList, Fragment as _Fragment, toDisplayString as _toDisplayString, createBlock as _createBlock, createElementVNode as _createElementVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-81539534"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  key: 0,
  class: "h-screen w100 progress"
}
const _hoisted_2 = {
  key: 0,
  class: "text-center"
}
const _hoisted_3 = {
  key: 1,
  class: "text-center"
}
const _hoisted_4 = { class: "text-center" }
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("thead", { class: "bg-primary" }, [
  /*#__PURE__*/_createElementVNode("tr", null, [
    /*#__PURE__*/_createElementVNode("th", { class: "text-left text-white font-weight-bold" }, " Usuário "),
    /*#__PURE__*/_createElementVNode("th", { class: "text-left text-white font-weight-bold" }, " Data "),
    /*#__PURE__*/_createElementVNode("th", { class: "text-left text-white font-weight-bold" }, " Data Vigencia "),
    /*#__PURE__*/_createElementVNode("th", { class: "text-left text-white font-weight-bold" }, " Sucesso "),
    /*#__PURE__*/_createElementVNode("th", { class: "text-left text-white font-weight-bold" }, " Ação ")
  ])
], -1))
const _hoisted_6 = { hidden: "" }
const _hoisted_7 = { class: "text-right" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_v_progress_circular = _resolveComponent("v-progress-circular")!
  const _component_v_expansion_panel_title = _resolveComponent("v-expansion-panel-title")!
  const _component_v_text_field = _resolveComponent("v-text-field")!
  const _component_v_col = _resolveComponent("v-col")!
  const _component_v_file_input = _resolveComponent("v-file-input")!
  const _component_v_btn = _resolveComponent("v-btn")!
  const _component_v_row = _resolveComponent("v-row")!
  const _component_v_container = _resolveComponent("v-container")!
  const _component_v_form = _resolveComponent("v-form")!
  const _component_v_card_title = _resolveComponent("v-card-title")!
  const _component_v_chip = _resolveComponent("v-chip")!
  const _component_v_card_item = _resolveComponent("v-card-item")!
  const _component_v_card = _resolveComponent("v-card")!
  const _component_v_expansion_panel_text = _resolveComponent("v-expansion-panel-text")!
  const _component_v_expansion_panel = _resolveComponent("v-expansion-panel")!
  const _component_v_divider = _resolveComponent("v-divider")!
  const _component_v_icon = _resolveComponent("v-icon")!
  const _component_v_table = _resolveComponent("v-table")!
  const _component_v_expansion_panels = _resolveComponent("v-expansion-panels")!

  return (_openBlock(), _createBlock(_component_v_card, { class: "h-screen" }, {
    default: _withCtx(() => [
      (_ctx.isLoading)
        ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
            _createVNode(_component_v_progress_circular, {
              class: "h-screen",
              "bg-color": "surface",
              color: "primary",
              indeterminate: "",
              size: 100,
              width: 20
            })
          ]))
        : _createCommentVNode("", true),
      _createVNode(_component_v_expansion_panels, {
        class: "mb-3 mt-3",
        modelValue: _ctx.panel,
        "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((_ctx.panel) = $event))
      }, {
        default: _withCtx(() => [
          _createVNode(_component_v_expansion_panel, null, {
            default: _withCtx(() => [
              _createVNode(_component_v_expansion_panel_title, { class: "font-weight-bold" }, {
                default: _withCtx(() => [
                  _createTextVNode(" Nova Atualizacao ")
                ]),
                _: 1
              }),
              _createVNode(_component_v_expansion_panel_text, null, {
                default: _withCtx(() => [
                  _createVNode(_component_v_form, {
                    ref: "form",
                    "validate-on": "blur",
                    onSubmit: _withModifiers(_ctx.atualizar, ["prevent"])
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_v_container, null, {
                        default: _withCtx(() => [
                          _createVNode(_component_v_row, { dense: true }, {
                            default: _withCtx(() => [
                              _createVNode(_component_v_col, { cols: "12" }, {
                                default: _withCtx(() => [
                                  _createVNode(_component_v_text_field, {
                                    density: "compact",
                                    readonly: true,
                                    modelValue: _ctx.usuarioLogado!.nome,
                                    "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.usuarioLogado!.nome) = $event)),
                                    label: "Usuário"
                                  }, null, 8, ["modelValue"])
                                ]),
                                _: 1
                              }),
                              _createVNode(_component_v_col, {
                                cols: "12",
                                sm: "6",
                                md: "6"
                              }, {
                                default: _withCtx(() => [
                                  _createVNode(_component_v_text_field, {
                                    type: "date",
                                    density: "compact",
                                    modelValue: _ctx.dataVigencia,
                                    "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.dataVigencia) = $event)),
                                    modelModifiers: { lazy: true },
                                    label: "Data Vigência"
                                  }, null, 8, ["modelValue"])
                                ]),
                                _: 1
                              }),
                              _createVNode(_component_v_col, {
                                cols: "12",
                                sm: "6",
                                md: "6"
                              }, {
                                default: _withCtx(() => [
                                  _createVNode(_component_v_text_field, {
                                    density: "compact",
                                    modelValue: _ctx.descricao,
                                    "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.descricao) = $event)),
                                    label: "Descricao"
                                  }, null, 8, ["modelValue"])
                                ]),
                                _: 1
                              }),
                              _createVNode(_component_v_col, { cols: "12" }, {
                                default: _withCtx(() => [
                                  _createVNode(_component_v_file_input, {
                                    density: "compact",
                                    label: "File input",
                                    modelValue: _ctx.arquivo,
                                    "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.arquivo) = $event)),
                                    accept: "*.xls,*.xlsx,application/vnd.openxmlformats-officedocument.spreadsheetml.sheet,application/excel"
                                  }, null, 8, ["modelValue"])
                                ]),
                                _: 1
                              }),
                              _createVNode(_component_v_col, { cols: "12" }, {
                                default: _withCtx(() => [
                                  _createVNode(_component_v_btn, {
                                    color: "primary",
                                    size: "large",
                                    type: "submit",
                                    variant: "outlined",
                                    class: "mt-4 w-100"
                                  }, {
                                    default: _withCtx(() => [
                                      _createTextVNode(" Confirmar ")
                                    ]),
                                    _: 1
                                  })
                                ]),
                                _: 1
                              })
                            ]),
                            _: 1
                          })
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  }, 8, ["onSubmit"]),
                  (_ctx.detalheErro)
                    ? (_openBlock(), _createBlock(_component_v_card, { key: 0 }, {
                        default: _withCtx(() => [
                          _createVNode(_component_v_card_title, {
                            class: "bg-warn",
                            visible: "false"
                          }, {
                            default: _withCtx(() => [
                              (_ctx.detalheErro.erro)
                                ? (_openBlock(), _createElementBlock("span", _hoisted_2, " Erros Atualizacao "))
                                : _createCommentVNode("", true),
                              (!_ctx.detalheErro.erro)
                                ? (_openBlock(), _createElementBlock("span", _hoisted_3, " Arquivo é válido "))
                                : _createCommentVNode("", true)
                            ]),
                            _: 1
                          }),
                          _createVNode(_component_v_card_item, null, {
                            default: _withCtx(() => [
                              _createElementVNode("div", _hoisted_4, [
                                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.detalheErro.detalhes, (index, value) => {
                                  return (_openBlock(), _createBlock(_component_v_chip, {
                                    class: "ma-2",
                                    density: "compact",
                                    color: index ? 'primary' : 'red',
                                    key: index
                                  }, {
                                    default: _withCtx(() => [
                                      _createTextVNode(_toDisplayString(value), 1)
                                    ]),
                                    _: 2
                                  }, 1032, ["color"]))
                                }), 128))
                              ])
                            ]),
                            _: 1
                          })
                        ]),
                        _: 1
                      }))
                    : _createCommentVNode("", true)
                ]),
                _: 1
              })
            ]),
            _: 1
          }),
          _createVNode(_component_v_expansion_panel, null, {
            default: _withCtx(() => [
              _createVNode(_component_v_expansion_panel_title, { class: "font-weight-bold" }, {
                default: _withCtx(() => [
                  _createTextVNode(" Histórico Atualizações ")
                ]),
                _: 1
              }),
              _createVNode(_component_v_expansion_panel_text, null, {
                default: _withCtx(() => [
                  _createElementVNode("form", {
                    onSubmit: _cache[6] || (_cache[6] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.filtrar && _ctx.filtrar(...args)), ["prevent"]))
                  }, [
                    _createVNode(_component_v_row, { dense: true }, {
                      default: _withCtx(() => [
                        _createVNode(_component_v_col, { cols: "5" }, {
                          default: _withCtx(() => [
                            _createVNode(_component_v_text_field, {
                              density: "compact",
                              label: "Data Início",
                              modelValue: _ctx.dataInicioFiltro,
                              "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.dataInicioFiltro) = $event)),
                              type: "date"
                            }, null, 8, ["modelValue"])
                          ]),
                          _: 1
                        }),
                        _createVNode(_component_v_col, { cols: "5" }, {
                          default: _withCtx(() => [
                            _createVNode(_component_v_text_field, {
                              density: "compact",
                              label: "Data Final",
                              type: "date",
                              modelValue: _ctx.dataFinalFiltro,
                              "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.dataFinalFiltro) = $event))
                            }, null, 8, ["modelValue"])
                          ]),
                          _: 1
                        }),
                        _createVNode(_component_v_col, { cols: "2" }, {
                          default: _withCtx(() => [
                            _createVNode(_component_v_btn, { type: "submit" }, {
                              default: _withCtx(() => [
                                _createTextVNode("Filtar")
                              ]),
                              _: 1
                            })
                          ]),
                          _: 1
                        })
                      ]),
                      _: 1
                    })
                  ], 32),
                  _createVNode(_component_v_divider),
                  _createVNode(_component_v_table, {
                    density: "compact",
                    class: "elevation-1"
                  }, {
                    default: _withCtx(() => [
                      _hoisted_5,
                      _createElementVNode("tbody", null, [
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.listaAtualizacoes.content, (item, i) => {
                          return (_openBlock(), _createElementBlock("tr", {
                            key: item.id
                          }, [
                            _createElementVNode("td", _hoisted_6, _toDisplayString(i), 1),
                            _createElementVNode("td", null, _toDisplayString(item.usuario), 1),
                            _createElementVNode("td", null, _toDisplayString(new Date(item.horario).toLocaleString('pt-BR', { timeZone: 'UTC' })), 1),
                            _createElementVNode("td", null, _toDisplayString(new Date(item.dataVigencia).toLocaleDateString('pt-BR', { timeZone: 'UTC' })), 1),
                            _createElementVNode("td", null, [
                              _createVNode(_component_v_icon, {
                                size: "large",
                                title: "sucesso",
                                color: item.sucesso ? 'green' : 'red',
                                icon: item.sucesso ? 'mdi-check-circle' : 'mdi-close-circle'
                              }, null, 8, ["color", "icon"])
                            ]),
                            _createElementVNode("td", _hoisted_7, [
                              _createVNode(_component_v_icon, {
                                size: "large",
                                icon: "mdi-zip-box",
                                title: "Download Receita",
                                color: "primary",
                                onClick: ($event: any) => (_ctx.downloadReceita(item.id))
                              }, null, 8, ["onClick"]),
                              _createVNode(_component_v_icon, {
                                size: "large",
                                icon: "mdi-file-excel",
                                title: "Download Excel",
                                color: "primary",
                                onClick: ($event: any) => (_ctx.downloadExcel(item.id))
                              }, null, 8, ["onClick"])
                            ])
                          ]))
                        }), 128))
                      ])
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              })
            ]),
            _: 1
          })
        ]),
        _: 1
      }, 8, ["modelValue"])
    ]),
    _: 1
  }))
}